// extracted by mini-css-extract-plugin
module.exports = {"shippingAlert":"ShippingAlert_shippingAlert__vDvqM"};